<script setup lang="ts">

import OTPInput from "@/components/inputs/OTPInput.vue";
import Translator from '@/utils/common/Translator'
import {computed, defineProps, onBeforeUnmount, onMounted, ref} from "vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";

const {compactMode} = storeToRefs(useNamaFlagsStore());
const props = defineProps<{ otpLength?: number, resendDelay?: number }>();
let otp = ref("");
let emit = defineEmits(['confirmOTPClicked', 'resendOTPClicked']);
let timeLeftInSeconds = ref(props.resendDelay ?? 60);
let timer: any = null;
let counterString = computed(() => {
  const minutes = Math.floor(timeLeftInSeconds.value / 60);
  const seconds = timeLeftInSeconds.value % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
});

function startCounter() {
  timer = setInterval(() => {
    timeLeftInSeconds.value--;
    if (timeLeftInSeconds.value === 0) {
      clearInterval(timer!);
    }
  }, 1000);
}

onMounted(() => {
  startCounter();
});

onBeforeUnmount(() => {
  clearInterval(timer!);
});

function onApplyClick() {
  if (!validateOTP()) {
    useErrorsStore().pushErrorStr("OTP -" + otp.value + "- is not valid");
    return;
  }
  emit('confirmOTPClicked', otp.value);
}

function onResendOTPClicked() {
  timeLeftInSeconds.value = props.resendDelay ?? 60;
  startCounter();
  emit('resendOTPClicked');
}

function validateOTP() {
  return otp.value && otp.value.length === props.otpLength;
}
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-justify-center tw-flex-col mobile:tw-justify-center">
    <div class="tw-w-2/3 tw-h-[45%] tw-flex tw-justify-around tw-items-center tw-flex-col tw-self-center
              mobile:tw-w-full mobile:tw-justify-between mobile:tw-h-2/3">
      <h4 class="tw-text-center tw-text-primary-light dark:tw-text-gray-200 tw-font-bold tw-text-3xl mobile:tw-text-wrap mobile:tw-text-2xl">{{ Translator.translateId("otpCheckYouMessages") }}</h4>
      <OTPInput v-model="otp" :length="otpLength" @onApplyClick="onApplyClick"/>
      <div class="tw-w-full tw-flex tw-flex-col tw-items-center">
        <q-btn
          no-caps
          :label="Translator.translateId('Confirm')"
          @click.stop="onApplyClick"
          @keydown.enter="onApplyClick"
          :dense="compactMode"
          class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-xl tw-font-bold tw-rounded-md tw-min-w-[60%] tw-max-w-[60%]"/>
        <div class="tw-mt-2">
          <span class="tw-text-primary-light dark:tw-text-gray-200" v-if="timeLeftInSeconds > 0">{{ counterString }}</span>&nbsp;
          <a v-if="timeLeftInSeconds===0" @click="onResendOTPClicked" href="#">{{ Translator.translateId("sendAnotherCode?") }}</a>
          <span v-else-if="timeLeftInSeconds > 0" class="tw-text-gray-400 dark:tw-text-gray-500">{{
              Translator.translateId("sendAnotherCode?")
            }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
